import './styles/index.less'
// 引入windicss
import 'virtual:windi-utilities.css'

// 生成SVG ICON
import 'virtual:svg-icons-register'

import { createApp } from 'vue'
import App from './App.vue'
import { setupRoute, router } from '@/router'
import { setupRouterGuard } from '@/router/guard'
import { setupStore } from '@/store-pinia'
import { setupI18n } from '@/locales/setupI18n'
import setupPlugins from './plugins/setupPlugins'
import registerGlobalComponents from './components/registerGlobalComponents'
import { setupDirectives } from '@/directives'
// import { setupErrorMoniting, setupSentryMoniting } from '@/monitor'
import fbuAntdvComponents from 'fbu-antdv-components'
import 'fbu-antdv-components/dist/style.css'
import { setupExposeInMainWorld } from '@/composables/useExposeInMainWorld'

async function bootstrap() {
  const app = createApp(App)

  // 初始化错误监听
  // setupErrorMoniting(app)
  // setupSentryMoniting(app, router)

  // 注册vue-i18n
  await setupI18n(app)

  // 注册vuex
  setupStore(app)

  // 注册 vue-router
  setupRoute(app)

  // 初始化router守卫
  setupRouterGuard(router)

  // 注册全局组件
  registerGlobalComponents(app)
  app.use(fbuAntdvComponents)

  // 注册全局插件
  setupPlugins(app)

  // 初始化全局指令
  setupDirectives(app)

  setupExposeInMainWorld()

  app.mount('#app')
}

bootstrap()
